import { Component, DestroyRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params } from '@angular/router';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { AnalyticService } from 'src/app/core/service/analytic.service';

@Component({
  standalone: false,
  selector: 'app-analytic-view',
  templateUrl: './analytic-view.component.html',
  styleUrls: ['./analytic-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnalyticViewComponent implements OnInit
{
  @Input() public id: number;

  public frameHeight = '100vh';
  public url: string;

  constructor(
    private analyticService: AnalyticService,
    private route: ActivatedRoute,
    private messageHandlerService: MessageHandlerService,
    private readonly destroyRef: DestroyRef,
  )
  {
  }

  public ngOnInit(): void
  {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (params: Params) =>
      {
        this.id = +params.id;
        this.getAnalytic();
      }
    });
  }

  public onResized(): void
  {
    this.frameHeight = `${window.innerHeight - 120}px`;
  }

  private getAnalytic(): void
  {
    this.analyticService.getAnalyticById(this.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) =>
      {
        this.url = data.link;
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }
}
